// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Z3-z","hovered":"_3-z","hoverImage":"a4-z","mainImage":"b4-z","imageNoBackground":"c4-z","fullSizeImage":"d4-z"};